<template>
  <v-tab
    v-bind="props"
    :value="value"
    variant="flat"
    class="me-1 tab-unselected rounded-t-lg border-t-sm border-s-sm border-e-sm"
    :class="{ 'tab-error': hasErrors }"
    selected-class="tab-selected"
  >
    <v-icon
      v-if="hasErrors"
      icon="fas fa-circle-exclamation"
      size="small"
      class="me-2"
      data-testid="tab-error-icon"
    />
    <slot>{{ text }}</slot>
  </v-tab>
</template>

<script setup lang="ts">
const props = defineProps<{
  text?: string;
  value: string | number;
  active: boolean;
  hasErrors?: boolean;
}>();
</script>
